import { render, staticRenderFns } from "./inputFile.vue?vue&type=template&id=2862aa72&scoped=true&"
import script from "./inputFile.vue?vue&type=script&lang=js&"
export * from "./inputFile.vue?vue&type=script&lang=js&"
import style0 from "./inputFile.vue?vue&type=style&index=0&id=2862aa72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2862aa72",
  null
  
)

export default component.exports